<template src="./index.html">
</template>
<script>
	import {
		getdata
	} from './data.js'
	import minhead from '../../../../common/minHead/index.vue'
	import cztdsys from './cztdsysitem/index.vue'
	import cjjzfcs from './cjjzfcs/index.vue'
	import czjzfcs from './czjzfcs/index.vue'

	export default {
		name: '',
		components: {
			minhead,
			cztdsys,
			cjjzfcs,
			czjzfcs
		},
		props: {
			outlistx: {
				type: Object,
				default: {}
			},
			mxsearch: {
				type: Object,
				default: {}
			},

		},
		data: function() {
			return {
				searchdata: getdata().searchdata,
				searchlist: getdata().searchlist,
				outlist: [],
				searchdiag: false,
				TitleData: [{
						label: "城镇土地使用税"
					},
					{
						label: "从价计征房产税"
					},
					{
						label: "从租计征房产税"
					}
				],
				chooseindex: 0,
				shaidiag: false,
				headData: [],
			};
		},
		created() {
			this.$nextTick(() => {
				this.mxsearch_is = JSON.parse(JSON.stringify(this.mxsearch))
				Object.keys(this.mxsearch).map(key => {
					let arr = Object.keys(this.mxsearch[key]).map(keyout => {
						return {
							value: this.mxsearch[key][keyout],
							label: keyout
						}
					})
					this.mxsearch[key] = arr
				})
				this.changeindex(0)
			})
		},
		methods: {
			closeshaidiag() {

			},
			confirmfilter() {

			},
			forback() {
				this.$emit("forback", "")
			},
			changeindex(e) {
				this.chooseindex = e
				if (e == 1) {
					this.searchlist = [{
							prop: "nsrlx",
							label: '纳税人类型',
							type: "select",
							selectval: []
						},
						{
							prop: "suoyqMc",
							label: '所有权名称',
							type: "input"
						},
						{
							prop: "fangcbh",
							label: '房产编号',
							type: "input"
						},
						{
							prop: "budcqzh",
							label: '不动产权证号',
							type: "input"
						},
						{
							prop: "fangcmc",
							label: '房产名称',
							type: "input"
						},
					]
					this.searchlist[0].selectval = this.mxsearch.cjjzTdbglxNsywzz
					this.searchdata = {
						nsrlx: '',
						suoyqMc: '',
						fangcbh: '',
						budcqzh: "",
						fangcmc: '',
					}
				} else if (e == 0) {
					this.searchlist = [{
							prop: "nsrlx",
							label: '纳税人类型',
							type: "select",
							selectval: []
						},
						{
							prop: "tudxz",
							label: '土地性质',
							type: "select",
							selectval: this.mxsearch.cztdTdxz
						},
						{
							prop: "tudmc",
							label: '土地名称',
							type: "input"
						},
						{
							prop: "tudqdfs",
							label: '土地取得方式',
							type: "select",
							selectval: this.mxsearch.cztdTdqdfs
						},
						{
							prop: "tudyt",
							label: '土地用途',
							type: "select",
							selectval: this.mxsearch.cztdTdyt
						}
					]
					this.searchlist[0].selectval = this.mxsearch.cztdNsrxz
					this.searchdata = {
						nsrlx: '',
						tudmc: '',
						tudqdfs: "",
						tudyt: '',
						tudxz: '',
					}
				} else {
					this.searchlist = [{
							prop: "chuzfcmj",
							label: '出租面积',
							type: "input"
						},
						{
							prop: "fangcmc",
							label: '房产名称',
							type: "input"
						},
						{
							prop: "shenbzjsr",
							label: '申报租金收入',
							type: "input"
						},
					]
					this.searchdata = {
						chuzfcmj: '',
						fangcmc: '',
						shenbzjsr: '',
					}
				}

			},
			submitSearch() {
				if (this.chooseindex == '0') {
					this.$refs.outset.chpage('')
				} else if (this.chooseindex == '1') {
					this.$refs.outset1.change('')
				} else if (this.chooseindex == '2') {
					this.$refs.outset2.chpage('')
				}
			},
			forRefresh() {
				this.pagination.pageNum = 1
				this.pagination.paginationkey++
			},
			forUpdateSearch() {
				this.searchdiag = true
			},
			closeSearch() {
				this.searchdiag = false
			},
			saveChange(e) {
				this.searchdiag = false
			},
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
</style>